import './App.css';
import RouteComponent from './routes/routes';

function App() {
  return (
    <div className="App">
      <RouteComponent />
    </div>
  );
}

export default App;
